<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @print="print"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="PurReturnHeadViewInfo"
                        :filter_language="['Order_Status','Finance_Status','invoice_flag','Negative_Flag']"
                        :filter_thousandth_puramount="['Total_Amount']"
                        :filter_date="['Finance_Date','Audit_Date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleCurrentChanges="handleCurrentChanges"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @current-change="handleCurrentChanges"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_No" :label="$t('getapi[3102]')">
                        <template scope="scope">
                            <input
                                    type="text"
                                    class="fsd clerinput"
                                    @keydown="keydown($event, scope.$index)"
                                    @keyup="keyup($event, scope.row)"
                                    v-model="scope.row.Order_No"
                                    readonly
                            />
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="PO_Code" :label="$t('getapi[1710]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Payment_Mode"
                                     :label="$t('getapi[1099]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Date"
                                     :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person"
                                     :label="$t('getapi[1858]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Date"
                                     :label="$t('getapi[1859]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Person"
                                     :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date"
                                     :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Negative_Flag"
                                     :label="$t('getapi[1860]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Finance_Status"
                                     :label="$t('getapi[1862]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Total_Amount" :label="$t('getapi[1863]')"
                                     align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_flag"
                                     :label="$t('getapi[1865]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_category"
                                     :label="$t('getapi[1866]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="audit" :disabled="!btn.Audit">{{
                            $t('getapi[3607]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="keepAccount" :disabled="!btn.Balance">{{
                            $t('getapi[3753]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="recoveryAccount" :disabled="!btn.RBalance">{{
                            $t('getapi[1869]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="showRemark" :disabled="!btn.remark">{{showRemarkNmae}}</el-button>
                    </div>
                    <div  style="width:950px">
                        <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.ReturnHead.order_no" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[1099]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.ReturnHead.payment_mode" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:100px;">
                                <!--{{expStatus(dataDetail.ReturnHead.order_status)}}-->
                                <el-input :value="expStatus(dataDetail.ReturnHead.order_status)" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[1862]') }}</td>
                            <td style="width:100px;">
                                <!--{{expFinanceStatus(dataDetail.ReturnHead.finance_status)}}-->
                                <el-input :value="expFinanceStatus(dataDetail.ReturnHead.finance_status)" type="text"
                                          size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[4470]') }}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="6" v-if="dataDetail.ReturnHead.order_status == 0">
                                <el-input
                                        v-model="dataDetail.ReturnHead.regist_person"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.ReturnHead.regist_person" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="dataDetail.ReturnHead.order_status != 0"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[3854]') }}</td>
                            <td>
                                <routejump :urlNo="29" v-if="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.ReturnHead.po_code"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectOrder()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.ReturnHead.po_code" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="addoredit != 1"></el-input>
                            </td>
                            <td>{{ $t('getapi[1857]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.ReturnHead.finance_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1866]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.ReturnHead.order_category" size="mini"
                                           :disabled="addoredit == 2">
                                    <el-option v-for="item in UseArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[1863]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.ReturnHead.total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                          align="right" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <!--<el-input v-model="dataDetail.ReturnHead.keep_person" type="text" size="mini"></el-input>-->
                                <routejump :urlNo="6" v-if="dataDetail.ReturnHead.order_status == 0">
                                <el-input
                                        v-model="dataDetail.ReturnHead.keep_person"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(2)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.ReturnHead.keep_person" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="dataDetail.ReturnHead.order_status != 0"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1196]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.ReturnHead.vender_code" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.ReturnHead.vender_name" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1865]') }}</td>
                            <td>
                                <!--{{dataDetail.ReturnHead.invoice_flag == 0?'否':'是'}}-->
                                <el-input
                                        :value="dataDetail.ReturnHead.invoice_flag == 0 ? $t('getapi[2053]') : $t('getapi[2052]')"
                                        type="text"
                                        size="mini"
                                        style="width:100%"
                                        :readonly="true" class="readO"
                                ></el-input>
                            </td>
                            <td>{{ $t('getapi[1167]') }}</td>
                            <td>
                                <!--<el-input v-model="dataDetail.ReturnHead.purchase_person" type="text" size="mini" style="width:100%"></el-input>-->
                                <routejump :urlNo="6" v-if="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.ReturnHead.purchase_person"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(3)"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.ReturnHead.purchase_person" type="text" size="mini"
                                          :readonly="true" class="readO" v-if="addoredit != 1"></el-input>
                            </td>
                        </tr>
                    </table>
                    </div>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[1872]')" name="0" id="xdetilpane-0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="showAddBom('')" :disabled="!btn.add_detail">{{ $t('getapi[6092]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.rowdel">{{
                                $t('getapi[1522]') }}
                            </el-button>
                        </div>
                        <vxe-table
                                :mouse-config="{area: true, extension: true}"
                                :data="dataDetail.ReturnLineNotAssist"
                                @checkbox-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameNot"
                                :highlight-current-row="true"
                                :height="tableHeight - 250"
                                resizable
                                show-overflow="tooltip"
                                :auto-resize="true"
                                header-row-class-name="headerclass"
                                border
                                size="mini"
                                style="width: 100%; margin-top:3px"
                                @sort-change="sortChange"
                                :default-sort="sortRule"
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" sortable
                                             align="right" width="50">
                                <!--<template scope="scope" v-if="dataDetail.ReturnHead.order_status == 0">
                                    <el-input size="mini" v-model="scope.row.line_no"></el-input>
                                </template>-->
                            </vxe-table-column>
                            <vxe-table-column field="relation_receivein_order_no"
                                             :title="$t('getapi[1936]')" sortable width="150">
                                <template slot-scope="scope">
                                    <!--<el-input size="mini" v-model="scope.row.relation_regist_order_no"
                                              @dblclick.native="showItem(scope)"></el-input>-->
                                    <el-input
                                            v-model="scope.row.relation_receivein_order_no"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.ReturnHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.relation_receivein_order_no}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_receivein_line_no"
                                             :title="$t('getapi[1937]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_code"
                                             :title="$t('getapi[112]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version"
                                             :title="$t('getapi[149]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name"
                                             :title="$t('getapi[116]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_model"
                                             :title="$t('getapi[124]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_spec"
                                             :title="$t('getapi[125]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measure"
                                             :title="$t('getapi[1166]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="freevalue"
                                             :title="$t('getapi[8958]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_groupid"   v-if="false"></vxe-table-column>   
<!--                                                      
                            <vxe-table-column show-footer-overflow field="freevalue" :title="$t('getapi[8958]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.freevalue" type="text" readonly
                                              size="mini" v-if="dataDetail.ReturnHead.order_status == 0 && freevalue">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="getpartgroup(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0 ">{{scope.row.page_free}}</span>
                                </template>
                            </vxe-table-column> -->
                            <vxe-table-column field="pur_measure_actually_qty"
                                             :title="$t('getapi[1933]')" sortable align="right" width="120">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.pur_measure_actually_qty" @change="getNotPurInvQty(scope,1)" v-if="dataDetail.ReturnHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.pur_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="exchange_rate" :title="$t('getapi[3599]')" sortable
                                             align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure"
                                             :title="$t('getapi[1340]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="inv_measure_actually_qty"
                                             :title="$t('getapi[1934]')" sortable align="right"  width="120">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.inv_measure_actually_qty" @change="getNotPurInvQty(scope,2)" v-if="dataDetail.ReturnHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.inv_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="batch_no"
                                             :title="$t('getapi[1763]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="sequence_no"
                                             :title="$t('getapi[1764]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="unit_price" :title="$t('getapi[1410]')" sortable
                                             align="right" v-if="authority_showprice" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[1881]')" sortable
                                             align="right" v-if="authority_showprice" width="100"></vxe-table-column>
                            <vxe-table-column field="cargoposition_code"
                                             :title="$t('getapi[1882]')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.cargoposition_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.ReturnHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showPurCargo(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.cargoposition_code}}</span>
                                </template>
                            </vxe-table-column>
                            
                            <vxe-table-column show-footer-overflow field="line_remark" :title="$t('getapi[4279]')" sortable v-if="showLineRemark" align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="createinvoiceqty" :title="$t('getapi[1884]')" sortable
                                             align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="releaseinvoiceqty" :title="$t('getapi[1885]')" sortable
                                             align="right" width="100"></vxe-table-column>

                                             <!-- showRemarkNmae -->
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1886]')" name="1" id="xdetilpane-1">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="showAddAssisBom('')" :disabled="!btn.assist_add_detail">{{ $t('getapi[6092]')
                                }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDelAssis" :disabled="!btn.assist_rowdel">{{
                                $t('getapi[1522]') }}
                            </el-button>
                        </div>
                        <vxe-table
                                :data="dataDetail.ReturnLineHasAssist"
                                :height="tableHeight - 250"
                                :highlight-current-row="true"
                                border
                                size="mini"
                                style="width: 100%; margin-top:3px"
                                resizable
                                show-overflow="tooltip"
                                @checkbox-change="handleSelectionChangeAssis"
                                :row-class-name="tableRowClassNameHas"
                                @sort-change="sortChangeHas"
                                :default-sort="sortRule"
                                ref="singleTable2"
                        >
                            <vxe-table-column type="checkbox" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_no" :title="$t('getapi[1425]')" sortable
                                             align="right" width="50"></vxe-table-column>
                            <vxe-table-column field="relation_regist_order_no"
                                             :title="$t('getapi[1936]')" sortable width="150">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.relation_receivein_order_no"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.ReturnHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddAssisBom(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.relation_receivein_order_no}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="relation_receivein_line_no"
                                             :title="$t('getapi[1937]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_code"
                                             :title="$t('getapi[112]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_version"
                                             :title="$t('getapi[149]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_name"
                                             :title="$t('getapi[116]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_model"
                                             :title="$t('getapi[124]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_spec"
                                             :title="$t('getapi[125]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="pur_measure"
                                             :title="$t('getapi[1166]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="freevalue"
                                             :title="$t('getapi[8958]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="part_groupid"   v-if="false"></vxe-table-column>                            
<!--                             
                            <vxe-table-column show-footer-overflow field="freevalue" :title="$t('getapi[8958]')" sortable width="100">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.freevalue" type="text" readonly
                                              size="mini" v-if="dataDetail.ReturnHead.order_status == 0 && freevalue">
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="getassispartgroup(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0 ">{{scope.row.page_free}}</span>
                                </template>
                            </vxe-table-column> -->
                            <vxe-table-column field="pur_measure_actually_qty"
                                             :title="$t('getapi[1933]')" sortable align="right" width="120">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.pur_measure_actually_qty" @change="getPurOInvQty(scope,1)" v-if="dataDetail.ReturnHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.pur_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="exchange_rate" :title="$t('getapi[3599]')" sortable
                                             align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="inv_measure"
                                             :title="$t('getapi[1340]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="inv_measure_actually_qty"
                                             :title="$t('getapi[1934]')" sortable align="right"  width="120">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.inv_measure_actually_qty" @change="getPurOInvQty(scope,2)" v-if="dataDetail.ReturnHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.inv_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="assist_measure"
                                             :title="$t('getapi[130]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column field="assist_measure_actually_qty"
                                             :title="$t('getapi[1941]')" sortable align="right" width="100">
                                <template slot-scope="scope">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                              v-model="scope.row.assist_measure_actually_qty" @change="getPurAInvQty(scope)" v-if="dataDetail.ReturnHead.order_status == 0"></el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.assist_measure_actually_qty}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="batch_no"
                                             :title="$t('getapi[1763]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="sequence_no"
                                             :title="$t('getapi[1764]')" sortable width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="unit_price" :title="$t('getapi[1410]')" sortable
                                             align="right" v-if="authority_showprice" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[1881]')" sortable
                                             align="right" v-if="authority_showprice" width="100"></vxe-table-column>
                            <vxe-table-column field="cargoposition_code"
                                             :title="$t('getapi[1882]')" sortable width="120">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.cargoposition_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                            v-if="dataDetail.ReturnHead.order_status == 0"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showPurCargoAssis(scope)"></i>
                                    </el-input>
                                    <span v-if="dataDetail.ReturnHead.order_status != 0">{{scope.row.cargoposition_code}}</span>
                                </template>
                            </vxe-table-column>
                            <vxe-table-column show-footer-overflow field="line_remark" :title="$t('getapi[4279]')" sortable v-if="showLineRemark" align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="createinvoiceqty" :title="$t('getapi[1884]')" sortable
                                             align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="releaseinvoiceqty" :title="$t('getapi[1885]')" sortable
                                             align="right" width="100"></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1890]') }}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.ReturnHead.create_person" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[4043]') }}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.ReturnHead.audit_person" type="text" size="mini"
                                          style="width:100%" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[3691]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.ReturnHead.create_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[3692]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.ReturnHead.audit_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurReturnHeadViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[961]')" queryData="PurReturnHeadViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!--采购订单-->
        <!-- <order :isVisible="orderVisible" @getorder="getorder" ref="order"></order> -->

		<selector :isVisible="orderVisible" :isSplitPage=true :postUrl="'/Basic/Popup/GetPurOrderDataList'" @callback="getorder" ref="order"></selector>
		
        <!--人员-->
        <!-- <employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee> -->
		<selector :isVisible="employeeVisible" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee" ref="employee"></selector>
        <!--主计量-->
        <!-- <returnorder :isVisible="returnVisible" @getreturnorder="getreturnorder" ref="returnorder"></returnorder> -->
		<!-- 多选 -->
		<selector :isVisible="returnVisible" :isBatch=true :selectType="0" :isSplitPage=true :postUrl="'/Pur/Return/GetPurReturnOrderNoPopupList'" @callback="getreturnorder" ref="returnorder"></selector>
		<!-- 单选 -->
		<selector :isVisible="returnVisible" :isBatch=false :selectType="0" :isSplitPage=true :postUrl="'/Pur/Return/GetPurReturnOrderNoPopupList'" @callback="getreturnorder" ref="returnordersingle"></selector>

        <!--次计量-->
        <!-- <returnassisorder :isVisible="returnAssisVisible" @getreturnassisorder="getreturnassisorder"
                          ref="returnassisorder"></returnassisorder> -->
		<!-- 多选 -->
		<selector :isVisible="returnAssisVisible" :isBatch=true :selectType="0" :isSplitPage=true :postUrl="'/Pur/Return/GetPurReturnAssisOrderNoPopupList'" @callback="getreturnassisorder" ref="returnassisorder"></selector>
		<!-- 单选 -->
		<selector :isVisible="returnAssisVisible" :isBatch=false :selectType="0" :isSplitPage=true :postUrl="'/Pur/Return/GetPurReturnAssisOrderNoPopupList'" @callback="getreturnassisorder" ref="returnassisordersingle"></selector>
        <!--货位代码-->
        <!--<purcargo :isVisible="purcargoVisible" @getpurcargo="getpurcargo" ref="purcargo"></purcargo>-->
        <selector :isVisible="purcargoVisible" :isSplitPage=true :postUrl="'/Pur/GRN/GetPurGRNCargoPPopupList'"
                  @callback="getpurcargo" ref="purcargo"></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupView'" @callback="partgroup"
                  ref="partgroup"></selector>
        <selector :isVisible="false" :isBatch="false" :isSplitPage="true"
                  :postUrl="'/Basic/Popup/GetPartGroupView'" @callback="assispartgroup"
                  ref="assispartgroup"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
		name:'purreturnview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purreturnview'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    ReturnHead: {},
                    ReturnLineNotAssist: [],
                    ReturnLineHasAssist: []
                }, // 编辑页面数据详情
                oldDataDetail: '',
                orderNo: '',
                UseArray: [
                    {
                        Code: '调账',
                        Name: this.$t('getapi[2903]')//'调账'
                    },
                    {
                        Code: '换货',
                        Name: this.$t('getapi[2902]')//'换货'
                    },
                    {
                        Code: '退货',
                        Name: this.$t('getapi[1950]')//'退货'
                    }
                ], // 计划类型数组
                isEdit: true, // 是否新增操作
                orderVisible: false, //
                itemVisible: false,

                employeeVisible: false,
                employeeType: 1,

                addoredit: -1, // 1.新增2：编辑
                oneormore: -1, // 1:单选2：多选
                rowindex: -1,
                oneormoreassis: -1, // 1:单选2：多选
                rowindexassis: -1,
                selectData: [],
                selectDataAssis: [],
                returnVisible: false,
                returnAssisVisible: false,
                purcargoVisible: false,
                purcargoType: 1, //1:一般物料2：此物料
                btn: {
                    //审核
                    Audit: false,
                    //记账
                    Balance: false,
                    //反记账
                    RBalance: false,
                    //删除明细
                    rowdel: false,
                    assist_rowdel: false,
                    //一般物料
                    add_detail: false,
                    //次计量
                    assist_add_detail: false,
                    remark:false,
                },
                authority_showprice: false,
                //行备注显影
                showLineRemark:false,
                showRemarkNmae:this.$t('getapi[1871]'),//"显示行备注",
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                RightSelectIndex: '0',
                //自由项
                freevalue: false,
                //自由项配置
                freeConfig:0,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                sortRule: {property:null,order:null},

                priceDigit:this.$store.state.digitsetting.pur_price_digit,
                amountDigit:this.$store.state.digitsetting.pur_amount_digit,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no, 1);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort()
            that.$processdata.pushModelCache('purreturnview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
            ///物料自由项是否启用
            if(that.freeConfig== 1){
                that.freevalue = true
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurReturnHeadViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassNameHas({ row, rowIndex }) {
                row.index = rowIndex;
            },
            tableRowClassNameNot({ row, rowIndex }) {
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[961]"),this.$t("getapi[16]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(that.$limits.authority('plv4', 261, 1) ==  1){
                    that.authority_showprice = true
                } else {
                    that.authority_showprice = false
                }
                //管理界面            
                if (that.$limits.authority('plv2', 218, 1) == 1) {
                    //只读权
                    if (!that.$limits.fnIsEmpty(that.dataDetail.ReturnHead.order_no)) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }

                }
                else if (that.$limits.authority('plv2', 218, 1) == 2) {
                    if (that.$limits.authority('plv3', 218,1) == 0) {
                        if (!that.$limits.fnIsEmpty(that.dataDetail.ReturnHead.order_no)) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 218,1) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.ReturnHead.order_no)) {
                            if (that.dataDetail.ReturnHead.order_status == 0) {
                                if (that.$limits.authority('plv4', 157, 1) == 1) {
                                    //打印
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    //预览
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            } else {
                                //预览
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 218, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.ReturnHead.order_no)) {
                            if (that.dataDetail.ReturnHead.order_status > 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else {
                                if (that.$limits.authority('plv4', 157, 1) == 1) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                }
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
					if (that.$limits.authority('plv2', 217, 1) > 0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                }
                if(that.dataDetail.ReturnHead.order_status ==1){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                //审核
                that.btn.Audit = false;
                //记账
                that.btn.Balance = false;
                //反记账
                that.btn.RBalance = false;
                //删除明细
                that.btn.rowdel = false;
                //一般物料mou
                that.btn.add_detail=false;
                //次计量
                that.btn.assist_add_detail=false;
                that.btn.assist_rowdel=false;
                that.btn.remark=false;
                if (that.$limits.authority('plv4', 163, 1) == 1) {
                    that.btn.remark=true ;
                }
                else{
                    that.btn.remark=false;
                }
                if (that.dataDetail.ReturnHead.order_status == 0) {
                    //一般物料
                    that.btn.add_detail=true;
                    //次计量
                    that.btn.assist_add_detail=true;
                    if (that.selectData.length > 0) {
                        if (that.dataDetail.ReturnHead.finance_status != 2) {
                            //不等于月结
                            //删除明细
                            that.btn.rowdel = true;
                        }
                    }
                }

                if (that.dataDetail.ReturnHead.order_status == 0) {
                    if (that.selectDataAssis.length > 0) {
                        if (that.dataDetail.ReturnHead.finance_status != 2) {
                            //不等于月结
                            //删除明细
                            that.btn.assist_rowdel = true;
                        }
                    }
                }

                if (!that.$limits.fnIsEmpty(that.dataDetail.ReturnHead.order_no)) {
                    //单据状态
                    if (that.dataDetail.ReturnHead.order_status == 0) {
                        //生成
                        //审核
                        that.btn.Audit = true;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    if (that.dataDetail.ReturnHead.order_status == 1) {
                        //审核
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    // console.log("财务状态:"+that.dataDetail.InHead.finance_status);
                    //财务状态
                    if (that.dataDetail.ReturnHead.finance_status == 0) {
                        //核算
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = true;
                        //反记账
                        that.btn.RBalance = false;
                    }
                    if (that.dataDetail.ReturnHead.finance_status == 1) {
                        //记账
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = true;
                    }
                    if (that.dataDetail.ReturnHead.finance_status == 2) {
                        //月结
                        //审核
                        that.btn.Audit = false;
                        //记账
                        that.btn.Balance = false;
                        //反记账
                        that.btn.RBalance = false;
                    }
                }

                //权限控制
                if (that.btn.Audit == true) {
                    if (that.$limits.authority('plv4', 157, 1) == 1) {
                        that.btn.Audit = true;
                    } else {
                        that.btn.Audit = false;
                    }
                }
                if (that.btn.Balance == true) {
                    if (that.$limits.authority('plv4', 159, 1) == 1) {
                        that.btn.Balance = true;
                    } else {
                        that.btn.Balance = false;
                    }
                }
                if (that.btn.RBalance == true) {
                    if (that.$limits.authority('plv4', 160, 1) == 1) {
                        that.btn.RBalance = true;
                    } else {
                        that.btn.RBalance = false;
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
				if (val != null) {
					let result = this.dataSet.findIndex(item => item.Order_No === val.Order_No);
					let fsd = document.getElementsByClassName('fsd');
					fsd[result].focus();
					this.currentRow = val;
				}
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purreturnview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurReturnHeadViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Return/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.orderNo == row.Order_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.ReturnLineNotAssist.length;i++){
                        delete datacopy.ReturnLineNotAssist[i]['index']
                        delete datacopy.ReturnLineNotAssist[i]['_XID'];
                    }
                    for(let i = 0;i<datacopy.ReturnLineHasAssist.length;i++){
                        delete datacopy.ReturnLineHasAssist[i]['index']
                        delete datacopy.ReturnLineHasAssist[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.orderNo = row.Order_No;
                                that.nowPOCode = row.Order_No;
                                that.isEdit = true;
                                that.addoredit = 2;
                                that.getDetail(row.Order_No);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.orderNo = row.Order_No;
                        that.nowPOCode = row.Order_No;
                        that.isEdit = true;
                        that.addoredit = 2;
                        that.getDetail(row.Order_No);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_No) {
                let that = this;
                if (that.$limits.authority('plv2', 218, 1) < 1) {
                    return;
                }
                let parm = {
                    Code: order_No
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Return/GetPurReturnBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = []
                        that.selectDataAssis = [];
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        // console.log(that.oldDataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.ReturnLineNotAssist.length;i++){
                    delete datacopy.ReturnLineNotAssist[i]['index']
                    delete datacopy.ReturnLineNotAssist[i]['_XID'];
                }
                for(let i = 0;i<datacopy.ReturnLineHasAssist.length;i++){
                    delete datacopy.ReturnLineHasAssist[i]['index']
                    delete datacopy.ReturnLineHasAssist[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.isEdit = false;
                that.isShowEdit = true;
                that.addoredit = 1;
                that.orderNo = ''
                that.dataDetail = {
                    ReturnHead: {
                        order_no: '',
                        po_code: '',
                        purchase_person: '',
                        payment_mode: '',
                        finance_date: '',
                        create_person: '',
                        create_date: datetime,
                        audit_person: '',
                        audit_date: '',
                        negative_flag: 0,
                        order_status: 0,
                        finance_status: -1,
                        total_amount: 0,
                        remark: '',
                        vender_code: '',
                        vender_name: '',
                        modify_person: '',
                        modify_time: datetime,
                        keep_person: '',
                        regist_person: '',
                        order_category: '退货',
                        concurrent_time: '',
                        invoice_flag: 0
                    },
                    ReturnLineNotAssist: [],
                    ReturnLineHasAssist: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
               /* let that = this;
                that.getView();
                if(that.addoredit != 1){
                    that.getDetail(that.orderNo)
                } else {
                    that.add()
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.ReturnLineNotAssist.length;i++){
                    delete datacopy.ReturnLineNotAssist[i]['index']
                    delete datacopy.ReturnLineNotAssist[i]['_XID'];
                }
                for(let i = 0;i<datacopy.ReturnLineHasAssist.length;i++){
                    delete datacopy.ReturnLineHasAssist[i]['index']
                    delete datacopy.ReturnLineHasAssist[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 1){
                                that.getView();
                                that.getDetail(that.orderNo)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 1){
                        that.getView();
                        that.getDetail(that.orderNo)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
               /* let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pur/Return/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurReturnHeadViewInfo",
                    fromname: that.$t('getapi[961]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                parm.LangType =that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pur/Return/SaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = res.UniqueNum;
                        that.orderNo = res.UniqueNum
                        that.getDetail(parm);
                    }
                });
            },
            getpartgroup(data) {
                let that = this;
                that.rowindex = data.$rowIndex;
                let param = {
                    part_code:that.dataDetail.ReturnLineNotAssist[that.rowindex].part_code,
                    part_version:that.dataDetail.ReturnLineNotAssist[that.rowindex].part_version,
                };
                if (that.freeConfig == 1) {
                    that.$refs.partgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            partgroup(data){
                let that = this;
                that.dataDetail.ReturnLineNotAssist[that.rowindex].freevalue = data.freevalue;
                that.dataDetail.ReturnLineNotAssist[that.rowindex].part_groupid = data.exclusively_id;
            },
            getassispartgroup(data) {
                let that = this;
                that.rowindex = data.$rowIndex;
                let param = {
                    part_code:that.dataDetail.ReturnLineHasAssist[that.rowindex].part_code,
                    part_version:that.dataDetail.ReturnLineHasAssist[that.rowindex].part_version,
                };
                if (that.freeConfig == 1) {
                    that.$refs.assispartgroup.clearInput(true,param);
                }
                else {
                    that.$message({
                        type: 'info',
                        message: that.$t('getapi[8965]')
                    });
                }
            },
            assispartgroup(data){
                let that = this;
                that.dataDetail.ReturnLineHasAssist[that.rowindex].freevalue = data.freevalue;
                that.dataDetail.ReturnLineHasAssist[that.rowindex].part_groupid = data.exclusively_id;
            },
            //获取采购订单
            selectOrder() {
                let that = this;
                that.orderVisible = true;
                that.$refs.order.clearInput(this.orderVisible, false, 0);
            },
            // 获取订单信息
            getorder(data) {
                let that = this;
                console.log(data);
                that.dataDetail.ReturnHead.po_code = data.po_code;
                that.dataDetail.ReturnHead.payment_mode = data.payment_mode;
                that.dataDetail.ReturnHead.purchase_person = data.transact_person;
                that.dataDetail.ReturnHead.vender_code = data.vender_code;
                that.dataDetail.ReturnHead.vender_name = data.vender_name;
            },
            //获取一般物料与次计量管理物料最大行号
            getMaxLineNo()
            {
                let that = this;
                var ReturnInt = 0;
                for (var i = 0; i < that.dataDetail.ReturnLineHasAssist.length; i++)
                {
                    if (that.dataDetail.ReturnLineHasAssist[i].line_no > ReturnInt)
                    {
                        ReturnInt =that.dataDetail.ReturnLineHasAssist[i].line_no;
                    }
                }

                for (var j = 0; j < that.dataDetail.ReturnLineNotAssist.length; j++)
                {
                    if (that.dataDetail.ReturnLineNotAssist[j].line_no > ReturnInt)
                    {
                        ReturnInt = that.dataDetail.ReturnLineNotAssist[j].line_no;
                    }
                }
                return ReturnInt + 1;
            },
            // 新增物料
            showAddBom(row) {
                let that = this;
                if(that.dataDetail.ReturnHead.po_code == '' || that.dataDetail.ReturnHead.po_code == null){
                    that.$message.warning(that.$t('getapi[8743]'));//'订单号不能为空'
                    return
                }
                that.returnVisible = true;
                if (row == '') {
                    that.oneormore = 1;
					//that.$refs.returnorder.clearInput(that.returnVisible, that.dataDetail.ReturnHead.po_code, 0, true);
					let  param =  {
						po_code: that.dataDetail.ReturnHead.po_code
					}
					that.$refs.returnorder.clearInput(that.returnVisible, param);
                } else {
                    that.oneormore = 2;
					that.rowindex = row.$rowIndex;

					//that.$refs.returnorder.clearInput(that.returnVisible, that.dataDetail.ReturnHead.po_code, 0, false);
					let  param =  {
						po_code: that.dataDetail.ReturnHead.po_code
					}
					that.$refs.returnordersingle.clearInput(that.returnVisible, param);
                }
            },
            getreturnorder(data) {
                let that = this;
                console.log(data);
                data = data.filter(item => {
                    return that.dataDetail.ReturnLineNotAssist.every(item2 => {
                        return item.relation_regist_order_no + item.relation_regist_order_line_no != item2.relation_regist_order_no + item2.relation_regist_order_line_no;
                    });
                });
                if (that.oneormore == 1) {
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.ReturnLineNotAssist = [
                            ...that.dataDetail.ReturnLineNotAssist,
                            {
                                /*line_no: that.dataDetail.ReturnLineNotAssist.length + 1,
                                relation_order_no : data[i].relation_order_no,
                                relation_regist_order_no: data[i].relation_regist_order_no,
                                relation_regist_order_line_no: data[i].relation_regist_order_line_no,
                                part_code : data[i].part_code,
                                part_version : data[i].part_version,
                                part_name : data[i].part_name,
                                part_model : data[i].part_model,
                                part_spec : data[i].part_spec,
                                pur_measure: data[i].pur_measure,
                                pur_measure_actually_qty:data[i].pur_measure_actually_qty,
                                exchange_rate:data[i].exchange_rate,
                                inv_measure:data[i].inv_measure,
                                inv_measure_actually_qty: data[i].inv_measure_actually_qty,
                                assist_measure:data[i].assist_measure,
                                batch_no:data[i].batch_no,
                                sequence_no:data[i].sequence_no,
                                unit_price:data[i].unit_price,
                                cargoposition_code:data[i].cargoposition_code,*/
                                relation_order_no: '',
                                line_no: that.getMaxLineNo(),
                                relation_regist_order_no: data[i].relation_regist_order_no,
                                relation_regist_order_line_no: data[i].relation_regist_order_line_no,
                                part_code: data[i].part_code,
                                part_version: data[i].part_version,
                                part_name: data[i].part_name,
                                part_model: data[i].part_model,
                                part_spec: data[i].part_spec,
                                part_finance_type: '',
                                pur_measure: data[i].pur_measure,
                                pur_measure_receivable_qty: (-1) * data[i].pur_measure_actually_qty,
                                pur_measure_actually_qty: (-1) * data[i].pur_measure_actually_qty,
                                exchange_rate: data[i].exchange_rate,
                                inv_measure: data[i].inv_measure,
                                inv_measure_receivable_qty: (-1) * data[i].inv_measure_actually_qty,
                                inv_measure_actually_qty: (-1) * data[i].inv_measure_actually_qty,
                                assist_measure: data[i].assist_measure,
                                assist_measure_receivable_qty: 0,
                                assist_measure_actually_qty: 0,
                                batch_no: data[i].batch_no,
                                sequence_no: data[i].sequence_no,
                                unit_price: data[i].unit_price.toFixed(that.priceDigit),
                                line_total_amount:((-1) * data[i].inv_measure_actually_qty * data[i].unit_price).toFixed(that.amountDigit),
                                cargoposition_code: data[i].cargoposition_code,
                                line_remark: '',
                                already_invoice_qty: 0,
                                expiry_date: '',
                                po_line_id: data[i].relation_po_line_id,
                                releaseinvoiceqty: 0,
                                createinvoiceqty: 0,
                                consumption_date: '',
                                relation_receivein_order_no: data[i].relation_order_no,
                                relation_receivein_line_no: data[i].line_no,
                                part_groupid: data[i].part_groupid,
                                freevalue: data[i].freevalue,
                            }
                        ];
                    }
                } else {
                    for(let i = 0;i<that.dataDetail.ReturnLineNotAssist.length;i++){
                        if(data.relation_regist_order_no + data.relation_regist_order_line_no == that.dataDetail.ReturnLineNotAssist[i].relation_regist_order_no + that.dataDetail.ReturnLineNotAssist[i].relation_regist_order_line_no){
                            return
                        }
                    }
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].relation_order_no = '';
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].relation_regist_order_no = data.relation_regist_order_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].relation_regist_order_line_no = data.relation_regist_order_line_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_code = data.part_code;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_version = data.part_version;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_name = data.part_name;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_model = data.part_model;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_spec = data.part_spec;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_finance_type = '';
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].pur_measure = data.pur_measure;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].pur_measure_receivable_qty = (-1) * data.pur_measure_actually_qty;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].pur_measure_actually_qty = (-1) * data.pur_measure_actually_qty;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].exchange_rate = data.exchange_rate;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].inv_measure = data.inv_measure;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].inv_measure_receivable_qty = (-1) * data.inv_measure_actually_qty;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].inv_measure_actually_qty = (-1) * data.inv_measure_actually_qty;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].assist_measure = data.assist_measure;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].assist_measure_receivable_qty = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].assist_measure_actually_qty = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].batch_no = data.batch_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].sequence_no = data.sequence_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].unit_price = data.unit_price.toFixed(that.priceDigit);
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].line_total_amount = ((-1) * data.inv_measure_actually_qty * data.unit_price).toFixed(that.amountDigit);
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].cargoposition_code = data.cargoposition_code;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].line_remark = '';
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].already_invoice_qty = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].expiry_date = '';
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].po_line_id = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].releaseinvoiceqty = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].createinvoiceqty = 0;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].consumption_date = '';
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].relation_receivein_order_no = data.relation_order_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].relation_receivein_line_no = data.line_no;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].part_groupid = data.part_groupid;
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].freevalue = data.freevalue;
                }
            },
            showAddAssisBom(row) {
                let that = this;
                that.returnAssisVisible = true;
                if (row == '') {
					that.oneormoreassis = 1;
					//that.$refs.returnassisorder.clearInput(that.returnAssisVisible, that.dataDetail.ReturnHead.po_code, 0, true);
					//多选
					let  param =  {
						po_code: that.dataDetail.ReturnHead.po_code
					}
					that.$refs.returnassisorder.clearInput(that.returnAssisVisible, param);
                } else {
                    that.oneormoreassis = 2;
                    that.rowindexassis = row.$index;
					//that.$refs.returnassisorder.clearInput(that.returnAssisVisible, that.dataDetail.ReturnHead.po_code, 0, false);
					//单选
					let  param =  {
						po_code: that.dataDetail.ReturnHead.po_code
					}
					that.$refs.returnassisordersingle.clearInput(that.returnAssisVisible, param);
                }
            },
            getreturnassisorder(data) {
                let that = this;
                console.log(data)
                if (that.oneormoreassis == 1) {
                    data = data.filter(item => {
                        return that.dataDetail.ReturnLineHasAssist.every(item2 => {
                            return item.relation_regist_order_no + item.relation_regist_order_line_no != item2.relation_regist_order_no + item2.relation_regist_order_line_no;
                        });
                    });
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.ReturnLineHasAssist = [
                            ...that.dataDetail.ReturnLineHasAssist,
                            {
                                relation_order_no: '',
                                line_no: that.getMaxLineNo(),
                                relation_regist_order_no: data[i].relation_regist_order_no,
                                relation_regist_order_line_no: data[i].relation_regist_order_line_no,
                                part_code: data[i].part_code,
                                part_version: data[i].part_version,
                                part_name: data[i].part_name,
                                part_model: data[i].part_model,
                                part_spec: data[i].part_spec,
                                part_finance_type: '',
                                pur_measure: data[i].pur_measure,
                                pur_measure_receivable_qty: data[i].pur_measure_actually_qty,
                                pur_measure_actually_qty: data[i].pur_measure_actually_qty,
                                exchange_rate: data[i].exchange_rate,
                                inv_measure: data[i].inv_measure,
                                inv_measure_receivable_qty: data[i].inv_measure_actually_qty,
                                inv_measure_actually_qty:data[i].inv_measure_actually_qty,
                                assist_measure: data[i].assist_measure,
                                assist_measure_receivable_qty:data[i].assist_measure_actually_qty,
                                assist_measure_actually_qty:data[i].assist_measure_actually_qty,
                                batch_no: data[i].batch_no,
                                sequence_no: data[i].sequence_no,
                                unit_price: data[i].unit_price.toFixed(that.priceDigit),
                                line_total_amount:(data[i].inv_measure_actually_qty * data[i].unit_price).toFixed(that.amountDigit),
                                cargoposition_code: data[i].cargoposition_code,
                                line_remark: '',
                                already_invoice_qty: 0,
                                expiry_date: '',
                                po_line_id: data[i].relation_po_line_id,
                                releaseinvoiceqty: 0,
                                createinvoiceqty: 0,
                                consumption_date: '',
                                relation_receivein_order_no: data[i].relation_order_no,
                                relation_receivein_line_no: data[i].line_no,
                                part_groupid: data[i].part_groupid,
                                freevalue: data[i].freevalue,
                            }
                        ];
                    }
                } else {
                    for(let i = 0;i<that.dataDetail.ReturnLineHasAssist.length;i++){
                        if(data.relation_regist_order_no + data.relation_regist_order_line_no == that.dataDetail.ReturnLineHasAssist[i].relation_regist_order_no + that.dataDetail.ReturnLineHasAssist[i].relation_regist_order_line_no){
                            return
                        }
                    }
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].relation_order_no = '';
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].relation_regist_order_no = data.relation_regist_order_no,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].relation_regist_order_line_no = data.relation_regist_order_line_no,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_code = data.part_code,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_version = data.part_version,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_name = data.part_name,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_model = data.part_model,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_spec = data.part_spec,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_finance_type = '',
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].pur_measure = data.pur_measure,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].pur_measure_receivable_qty =  data.pur_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].pur_measure_actually_qty =  data.pur_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].exchange_rate = data.exchange_rate,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].inv_measure = data.inv_measure,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].inv_measure_receivable_qty = data.inv_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].inv_measure_actually_qty =  data.inv_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].assist_measure = data.assist_measure,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].assist_measure_receivable_qty =  data.assist_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].assist_measure_actually_qty = data.assist_measure_actually_qty,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].batch_no = data.batch_no,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].sequence_no = data.sequence_no,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].unit_price = data.unit_price.toFixed(that.priceDigit),
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].line_total_amount = (data.inv_measure_actually_qty * data.unit_price).toFixed(that.amountDigit),
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].cargoposition_code = data.cargoposition_code,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].line_remark = '',
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].already_invoice_qty = 0,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].expiry_date = '',
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].po_line_id = 0,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].releaseinvoiceqty = 0,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].createinvoiceqty = 0,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].consumption_date = '',
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].relation_receivein_order_no = data.relation_order_no,
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].relation_receivein_line_no = data.line_no;
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].part_groupid = data.part_groupid;
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].freevalue = data.freevalue;
                }
            },
            selectemployee(type) {
                let that = this;
                that.employeeVisible = true;
				that.employeeType = type; // 1保管员2记账员
                that.$refs.employee.clearInputFromFunc(this.employeeVisible, false, 3);
            },
            getemployee(data) {
                let that = this;
                if (that.employeeType == 1) {
                    that.dataDetail.ReturnHead.regist_person = data.name;
                } else if (that.employeeType == 2) {
                    that.dataDetail.ReturnHead.keep_person = data.name;
                } else {
                    that.dataDetail.ReturnHead.purchase_person = data.name;
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 2) {
                    return that.$t('getapi[1902]')//'作废';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            audit() {
                let that = this;
                let parm = {
                    order_no: that.dataDetail.ReturnHead.order_no,
                    po_code: that.dataDetail.ReturnHead.po_code,
                    LangType: that.$processdata.getLang(),
                };
                that.btn.Audit = false
                that.$http.urlpost('/Pur/Return/PurReturnAudit', parm, function (res) {
                    that.btn.Audit = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.orderNo);
                    }
                });
            },
            keepAccount() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.ReturnHead.po_code
                };
                that.btn.Balance = false
                that.$http.urlpost('/Pur/Return/GetPurReturnKeepAccount', parm, function (res) {
                    that.btn.Balance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.orderNo);
                    }
                });
            },
            recoveryAccount() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.ReturnHead.po_code
                };
                that.btn.RBalance = false
                that.$http.urlpost('/Pur/Return/GetPurReturnRecoveryAccount', parm, function (res) {
                    that.btn.RBalance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.orderNo);
                    }
                });
            },
            showRemark(){
                let that=this;
                if(that.showLineRemark){
                    that.showRemarkNmae= this.$t('getapi[1871]')//"显示行备注"
                    that.showLineRemark=false
                }
                else{
                    that.showRemarkNmae=this.$t('getapi[1920]')//"隐藏行备注";
                    that.showLineRemark=true
                }
            },
            print() {
                //判断状态
                let that = this;
                let parm = {
                    po_no: that.nowPOCode,
                    TemplateName: '06采购退货单.xlsx'
                };
                that.$http.urlpost('/Print/PRPrint', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange({ records }) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push(records[i]);
                }
                that.btnauthority();
            },
            handleSelectionChangeAssis({records}) {
                let that = this;
                that.selectDataAssis = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectDataAssis.push(records[i]);
                }
                that.btnauthority();
            },
            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.ReturnHead.order_no,
                            modify_time: that.dataDetail.ReturnHead.modify_time,
                            LineList: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.ReturnLineNotAssist.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].relation_order_no!=""){
                                let datatmp = {
                                    relation_order_no:that.selectData[i].relation_order_no,
                                    line_no: that.selectData[i].line_no,
                                }
                                parm.LineList.push(datatmp);
                            }
                        }
                        if(parm.LineList.length>0){
                            that.$http.urlpost('/Pur/Return/PurReturnDelLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.orderNo != '') {
                                        that.getDetail(that.orderNo);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelAssis() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.ReturnHead.order_no,
                            modify_time: that.dataDetail.ReturnHead.modify_time,
                            LineList: []
                        };
                        for (let i = that.selectDataAssis.length - 1; i >= 0; i--) {
                            that.dataDetail.ReturnLineHasAssist.splice(that.selectDataAssis[i].index, 1);
                            if(that.selectDataAssis[i].relation_order_no!=""){
                                let datatmp = {
                                    relation_order_no:that.selectDataAssis[i].relation_order_no,
                                    line_no: that.selectDataAssis[i].line_no,
                                }
                                parm.LineList.push(datatmp);
                            }
                        }
                        if(parm.LineList.length>0){
                            that.$http.urlpost('/Pur/Return/PurReturnDelLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.orderNo != '') {
                                        that.getDetail(that.orderNo);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            showPurCargo(row) {
                let that = this;
                that.rowindex = row.$rowIndex;
                that.purcargoVisible = true;
                that.purcargoType = 1;
                let param = {
                    Code: '',
                    Name: '',
                }
                that.$refs.purcargo.clearInput(that.purcargoVisible, param);
            },
            showPurCargoAssis(row) {
                let that = this;
                that.rowindexassis = row.$rowIndex;
                that.purcargoVisible = true;
                that.purcargoType = 2;
                let param = {
                    Code: '',
                    Name: '',
                }
                that.$refs.purcargo.clearInput(that.purcargoVisible, param);
            },
            getpurcargo(data) {
                let that = this;
                if (that.purcargoType == 1) {
                    that.dataDetail.ReturnLineNotAssist[that.rowindex].cargoposition_code = data.cargoposition_code;
                } else if (that.purcargoType == 2) {
                    that.dataDetail.ReturnLineHasAssist[that.rowindexassis].cargoposition_code = data.cargoposition_code;
                }
            },
            //单据删除
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.ReturnHead.order_no,
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pur/Return/DelPurReturn', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 获取采购和库存计量实入数
            getPurAInvQty(row){
                let that = this
                let index = row.$rowIndex
                let parm = {
                    part_code: that.dataDetail.ReturnLineHasAssist[index].part_code,
                    part_version: that.dataDetail.ReturnLineHasAssist[index].part_version,
                    pur_measure_actually_qty: that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty,
                    exchange_rate: that.dataDetail.ReturnLineHasAssist[index].exchange_rate,
                    inv_measure_actually_qty: that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty,
                    unit_price: that.dataDetail.ReturnLineHasAssist[index].unit_price,
                    assist_measure: '',
                    assist_measure_actually_qty: that.dataDetail.ReturnLineHasAssist[index].assist_measure_actually_qty
                }
                that.$http.urlpost('/Pur/Return/GetPurReturnAssistQty', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent
                        that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty = data.pur_measure_actually_qty
                        that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty = data.inv_measure_actually_qty
                        that.dataDetail.ReturnLineHasAssist[index].line_total_amount = data.line_total_amount.toFixed(that.amountDigit)
                    }
                });
            },
            getPurOInvQty(row,type){
                let that = this
                let index = row.$rowIndex
                if(type == 1){
                    that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty = that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty * that.dataDetail.ReturnLineHasAssist[index].exchange_rate
                    that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty = that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty / that.dataDetail.ReturnLineHasAssist[index].exchange_rate
                    that.dataDetail.ReturnLineHasAssist[index].line_total_amount = (that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty * that.dataDetail.ReturnLineHasAssist[index].unit_price).toFixed(that.amountDigit)
                } else if (type == 2){
                    that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty = that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty / that.dataDetail.ReturnLineHasAssist[index].exchange_rate
                    that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty = that.dataDetail.ReturnLineHasAssist[index].pur_measure_actually_qty * that.dataDetail.ReturnLineHasAssist[index].exchange_rate
                    that.dataDetail.ReturnLineHasAssist[index].line_total_amount = (that.dataDetail.ReturnLineHasAssist[index].inv_measure_actually_qty * that.dataDetail.ReturnLineHasAssist[index].unit_price).toFixed(that.amountDigit)
                }
            },
            getNotPurInvQty(row,type){
                let that = this
                let index = row.$rowIndex
                if(type == 1){
                    that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty = that.dataDetail.ReturnLineNotAssist[index].pur_measure_actually_qty * that.dataDetail.ReturnLineNotAssist[index].exchange_rate
                    that.dataDetail.ReturnLineNotAssist[index].pur_measure_actually_qty = that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty / that.dataDetail.ReturnLineNotAssist[index].exchange_rate
                    that.dataDetail.ReturnLineNotAssist[index].line_total_amount = (that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty * that.dataDetail.ReturnLineNotAssist[index].unit_price).toFixed(that.amountDigit)
                } else if (type == 2){
                    that.dataDetail.ReturnLineNotAssist[index].pur_measure_actually_qty = that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty / that.dataDetail.ReturnLineNotAssist[index].exchange_rate
                    that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty = that.dataDetail.ReturnLineNotAssist[index].pur_measure_actually_qty * that.dataDetail.ReturnLineNotAssist[index].exchange_rate
                    that.dataDetail.ReturnLineNotAssist[index].line_total_amount = (that.dataDetail.ReturnLineNotAssist[index].inv_measure_actually_qty * that.dataDetail.ReturnLineNotAssist[index].unit_price).toFixed(that.amountDigit)
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 218,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.ReturnLineNotAssist.length;i++){
                    delete datacopy.ReturnLineNotAssist[i]['index']
                    delete datacopy.ReturnLineNotAssist[i]['_XID'];
                }
                for(let i = 0;i<datacopy.ReturnLineHasAssist.length;i++){
                    delete datacopy.ReturnLineHasAssist[i]['index']
                    delete datacopy.ReturnLineHasAssist[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
            sortChange(column){
                let that = this
                let name = column.property
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.ReturnLineNotAssist.indexOf(obj1) - that.dataDetail.ReturnLineNotAssist.indexOf(obj2);
                        }
                    }
                    that.dataDetail.ReturnLineNotAssist.sort(compare);
                    that.dataDetail.ReturnLineNotAssist = [...that.dataDetail.ReturnLineNotAssist]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.ReturnLineNotAssist.indexOf(obj2) - that.dataDetail.ReturnLineNotAssist.indexOf(obj1);
                        }
                    }
                    that.dataDetail.ReturnLineNotAssist.sort(compare);
                    that.dataDetail.ReturnLineNotAssist = [...that.dataDetail.ReturnLineNotAssist]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            sortChangeHas(column){
                let that = this
                let name = column.property
                console.log(column)
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.ReturnLineHasAssist.indexOf(obj1) - that.dataDetail.ReturnLineHasAssist.indexOf(obj2);
                        }
                    }
                    that.dataDetail.ReturnLineHasAssist.sort(compare);
                    that.dataDetail.ReturnLineHasAssist = [...that.dataDetail.ReturnLineHasAssist]
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.ReturnLineHasAssist.indexOf(obj2) - that.dataDetail.ReturnLineHasAssist.indexOf(obj1);
                        }
                    }
                    that.dataDetail.ReturnLineHasAssist.sort(compare);
                    that.dataDetail.ReturnLineHasAssist = [...that.dataDetail.ReturnLineHasAssist]
                }
                that.sortRule.order = column.order
                that.sortRule.property = column.property
            },
            selectInfo(tab){
                let that = this
                that.RightSelectIndex=tab.name
                this.$nextTick(function(){
                    this.$processdata.initFormRight(this.RightSelectIndex)
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
